var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 3v3m-9-3v3-3zM19 4.5H7a3 3 0 00-3 3V18a3 3 0 003 3h12a3 3 0 003-3V7.5a3 3 0 00-3-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3 11h3.5l-2.9 5"
  }))));
}
export default SvgCalendar;